//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.NullableAnyAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.CompleteInspectionMutation
import com.wintermar.inspection.graphql.type.InspectionStatus
import com.wintermar.inspection.graphql.type.adapter.InspectionStatus_ResponseAdapter
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object CompleteInspectionMutation_ResponseAdapter {
  public object Data : Adapter<CompleteInspectionMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("completeInspection")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): CompleteInspectionMutation.Data {
      var _completeInspection: CompleteInspectionMutation.CompleteInspection? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _completeInspection = CompleteInspection.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return CompleteInspectionMutation.Data(
        completeInspection = _completeInspection ?: missingField(reader, "completeInspection")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: CompleteInspectionMutation.Data,
    ) {
      writer.name("completeInspection")
      CompleteInspection.obj().toJson(writer, customScalarAdapters, value.completeInspection)
    }
  }

  public object CompleteInspection : Adapter<CompleteInspectionMutation.CompleteInspection> {
    public val RESPONSE_NAMES: List<String> = listOf("id", "status", "lastUpdatedAt")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): CompleteInspectionMutation.CompleteInspection {
      var _id: Any? = null
      var _status: InspectionStatus? = null
      var _lastUpdatedAt: Any? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _status = InspectionStatus_ResponseAdapter.fromJson(reader, customScalarAdapters)
          2 -> _lastUpdatedAt = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return CompleteInspectionMutation.CompleteInspection(
        id = _id ?: missingField(reader, "id"),
        status = _status ?: missingField(reader, "status"),
        lastUpdatedAt = _lastUpdatedAt
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: CompleteInspectionMutation.CompleteInspection,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("status")
      InspectionStatus_ResponseAdapter.toJson(writer, customScalarAdapters, value.status)

      writer.name("lastUpdatedAt")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.lastUpdatedAt)
    }
  }
}
